define('views/components/blacklist_user/user_list',['require','views/base/list_view','views/components/blacklist_user/user','text!templates/components/blacklist_user/user_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/blacklist_user/user');

    var temp = require("text!templates/components/blacklist_user/user_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

